import {Menu, Tooltip} from 'antd';
import * as React from 'react';
import {isBrowser, isTablet} from 'react-device-detect';
import {Link} from 'react-router-dom';
import {
  BankOutlined,
  CreditCardOutlined,
  DollarOutlined,
  InfoCircleOutlined,
  LockOutlined,
  LogoutOutlined,
  NotificationOutlined,
  ProfileOutlined,
  SettingOutlined,
  TeamOutlined,
  ToolOutlined,
  UserOutlined,
} from '@ant-design/icons';
import {findIconDefinition} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTags} from '@fortawesome/free-solid-svg-icons';

import {HeaderModalType} from '../../../../types/src';
import {brandConfig} from '../../utils';

const {SubMenu} = Menu;

export default function AccountMenu({onClick, team_member, client, isAdmin}: any) {
  const isDesktopOrTablet = isBrowser || isTablet;
  const shouldShowBilling =
    isDesktopOrTablet && client.type !== 'testing' && (client.subscription_account_id || isAdmin);

  // TODO does sequence of items in list matter
  // TODO rewrite items in sort of mapper below, but i dont know how yet
  const menuItems = [
    {
      key: HeaderModalType.SETTINGS,
      label: 'Settings',
      icon: <SettingOutlined />,
    },
    {
      key: HeaderModalType.MEMBERS,
      label: 'Manage Members',
      icon: <TeamOutlined />,
      disabled: team_member,
      tooltip: team_member && 'Only owner allowed to modify',
    },
    {
      key: HeaderModalType.NOTIFICATION_SETTINGS,
      label: 'Manage Notifications',
      icon: <NotificationOutlined />,
      disabled: team_member && !team_member?.user,
      tooltip: team_member && !team_member?.user && 'Only owner allowed to modify',
    },
    {
      key: HeaderModalType.PASSWORD,
      label: 'Change password',
      icon: <LockOutlined />,
      disabled: team_member,
      tooltip: team_member && 'Only owner allowed to modify',
    },
    {
      key: HeaderModalType.TAG_MANAGEMENT,
      label: 'Manage Tags',
      icon: <FontAwesomeIcon icon={faTags} />,
      disabled: team_member,
      tooltip: team_member && 'Only owner allowed to modify',
    },
  ];

  return (
    <Menu onClick={onClick} selectedKeys={[]} className="accountSwitcher_menu">
      {isDesktopOrTablet &&
        menuItems.map(item => (
          <Menu.Item key={item.key} disabled={item.disabled}>
            {item.tooltip ? (
              <Tooltip title={item.tooltip} onOpenChange={visible => (item.disabled ? visible : false)}>
                {item.icon} {item.label}
              </Tooltip>
            ) : (
              <>
                {item.icon} {item.label}
              </>
            )}
          </Menu.Item>
        ))}
      {shouldShowBilling && (
        <SubMenu
          key="1"
          title={
            <>
              <DollarOutlined /> Billing
            </>
          }
        >
          <Menu.Item key={HeaderModalType.SUBSCRIPTION} disabled={team_member}>
            {team_member && (
              <Tooltip title="Only owner allowed to modify" onOpenChange={visible => (team_member ? visible : false)}>
                <ToolOutlined /> Manage Subscription
              </Tooltip>
            )}
            {!team_member && (
              <>
                <ToolOutlined /> Manage Subscription
              </>
            )}
          </Menu.Item>
          {client.subscription_account_id && !brandConfig.isAffiliate && (
            <Menu.Item key={HeaderModalType.INVOICES} disabled={team_member}>
              <ProfileOutlined /> Invoices
            </Menu.Item>
          )}
          {client.subscription_account_id && !brandConfig.isAffiliate && (
            <Menu.Item key={HeaderModalType.PAYMENT} disabled={team_member}>
              <CreditCardOutlined /> Payment Methods
            </Menu.Item>
          )}
          {isAdmin && (
            <Menu.Item key="customer_billing">
              <BankOutlined /> Customer Billing
            </Menu.Item>
          )}
        </SubMenu>
      )}
      {isDesktopOrTablet && (
        <Menu.Item key={HeaderModalType.PROFILE}>
          <UserOutlined /> Profile
        </Menu.Item>
      )}
      {isDesktopOrTablet &&
        (client.k8s_support ? isAdmin : isAdmin || client.manage_cloud_feature) && (
        <Menu.Item key={HeaderModalType.ADMIN_TOOLS}>
          <FontAwesomeIcon
            style={{color: brandConfig.primaryColor, marginRight: '5px'}}
            icon={findIconDefinition({
              prefix: 'fas',
              iconName: 'user-shield',
            })}
          />{' '}
          Admin tools
        </Menu.Item>
      )}
      {brandConfig.isGx && isDesktopOrTablet && (
        <Menu.Item key={HeaderModalType.ABOUT_US}>
          <Link to={{pathname: 'https://cuegrowth.ai/'}} target={`_blank`}>
            <InfoCircleOutlined /> About us
          </Link>
        </Menu.Item>
      )}
      {isDesktopOrTablet && <Menu.Divider />}
      <Menu.Item key={HeaderModalType.LOGOUT}>
        <LogoutOutlined /> Log out
      </Menu.Item>
    </Menu>
  );
}
